<template>
  <div class="qrcode-container">
    <canvas :id="domId" width="100%" height="100%"></canvas>
    <div
      class="mask"
      :class="{
        'opacity-0': !expired && !used && !loading,
      }"
    >
      <div v-if="expired" class="tips">二维码已过期</div>
      <div v-if="used" class="tips">二维码已使用</div>
      <div v-if="loading" class="tips">
        <Loading style="min-height: unset" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import QRCode from 'qrcode';
import { onMounted, ref, watch } from 'vue';
import { safeGetElementById } from '../../utils/ssr';
import { Loading } from '../loading';

const props = withDefaults(
  defineProps<{
    url?: string;
    width?: number;
    used?: boolean;
    expired?: boolean;
    margin?: number;
    loading?: boolean;
  }>(),
  {
    margin: 0,
  },
);
const domId = ref(`qrcode_${Math.random()}`);

function genQrcode() {
  if (!props.url) return;
  const element = safeGetElementById(domId.value);
  if (!element) return;
  QRCode.toCanvas(element, props.url, {
    width: props.width,
    margin: props.margin,
  });
}

watch(
  () => props.url,
  () => {
    // 只在客户端执行
    if (typeof window !== 'undefined') {
      genQrcode();
    }
  },
);

onMounted(genQrcode);
</script>

<style scoped>
.qrcode {
  pointer-events: none;
  user-select: none;
}
.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}
.mask {
  position: absolute;
  inset: -2px;
  background-color: var(--x-black-8);
  display: flex;
  justify-content: center;
  align-items: center;
}
.tips {
  color: var(--x-text-3);
  font-size: var(--x-text-14-size);
  font-weight: var(--x-weight-regular);
  line-height: var(--x-text-14-line-height);
  background: var(--x-back-1);
  padding: 8px;
  border-radius: var(--x-radius-small);
}
.opacity-0 {
  visibility: hidden;
}
</style>
